export class CotizacionDetalle {
    public idCotizacionDetalle: number;
    public idValuacionDetalle: number;
    public idCotizacion: number;
    public obsValuacion: string;
    public descripcion: string;
    public obsCotizacion: string;
    public cantidad: number;
    public tipo: string;
    public precioUnitario: number;
    public total: number;
    public idOrdenServicio: number;
    public idEmpleado: number;
    public idProveedor: number;
    public proveedor: string;
    public cotizaciones: number;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/cotizacionDetalle.ts